import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

export default function TransportNowInfoBox() {

    const { id, speed } = useAppSelector(state => state.transportNow.transportMonitoringHovered) ?? {}

    return (
        <div className="transport-now-info-box">
            <div className="field-col">
                <span>Идентификатор ТС</span>
                <span>Скорость (км/ч)</span>
            </div>
            <div className="value-col">
                <span>{id}</span>
                <span>{speed}</span>
            </div>
        </div>
    )
}
